
<div class='component--listing_search--listing_search_creation_failure_message_modal-4-record_with_same_criteria_exist'>
  <div class='modal-header'>
    <strong class='component--listing_search--listing_search_creation_failure_message_modal-4-record_with_same_criteria_exist__heading'>
      <%= heading_text %>
    </strong>
    <button class='btn-close-modal' data-dismiss='modal'>&times;</button>
  </div>
  <div class='modal-body'>
    <div class='component--listing_search--listing_search_creation_failure_message_modal-4-record_with_same_criteria_exist__description'>
      <%= description_text %>
    </div>
  </div>
</div>
